import React from "react";
import clsx from "clsx";
import { makeStyles } from '@material-ui/core/styles';

import Container from "../../../../base/components/container.js.jsx";
import HtmlContent from "../../../../base/components/html_content.js";
import I18n from "../../../../base/i18n.js.jsx";
import ImageSmooth from "../../../../base/components/image_smooth.js";

import topPicture from "../resources/images/top_picture.jpg";
import topPictureNarrow from "../resources/images/top_picture_narrow.jpg";
import IcCheckSquare from "../resources/icons/ic_check_square white.js";

const topPictureThumbnail = "data:image/jpeg;base64,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"
const topPictureNarrowThumbnail = "data:image/jpeg;base64,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"


const padBlockHeight = 400;
const phoneBlockHeight = 360;

const maxAllowedImageWidth = 1650; // Found via experimental way for cut image https://www.shutterstock.com/image-photo/house-stone-figure-symbol-construction-real-590650646

const blockStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.white,
    height: `100vh`,
    position: "relative",
    ['@media (max-width: 992px)']: {
      height: `${padBlockHeight}px`,
    },
    ['@media (max-width: 768px)']: {
      height: `${phoneBlockHeight}px`,
    },
    overflow: "hidden"
  },
  checkMark: {
    float: "left"
  },
  checkMarkMobile: {
    float: "left",
    width: "15px"
  },
  checkMarkWrapper: {
    display: "flex",
    alignItems: "center",
    paddingBottom: "10px"
  },
  checkMarkText: {
    float: "left",
    paddingLeft: "10px"
  },
  imageWrapper: {
    display: "flex",
    justifyContent: "center",
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    zIndex: "1"
  },
  imageWide: {
    display: "block",
    height: "100%",
    width: "auto",
    transition: "opacity .7s ease",
    objectFit: "contain",
    ['@media (max-width: 700px)']: {
      display: "none",
    },
  },
  imageNarrow: {
    display: "none",
    height: "100%",
    width: "100%",
    objectFit: "cover",
    ['@media (max-width: 700px)']: {
      display: "block",
    },
  },
  content: {
    zIndex: 1,
    position: "relative",
    padding: "60px 0px 70px",
    ['@media (max-width: 992px)']: {
      padding: "40px 0px 50px",
    },
    ['@media (max-width: 768px)']: {
      padding: "36px 16px 50px",
    },
  },
  textsContainer: {
    backgroundColor: "rgba(229, 241, 246, 0.9)",
    padding: "40px 45px",
    width: "60%",
    textAlign: "left",
    ['@media (max-width: 992px)']: {
      width: "100%",
      padding: "36px 32px",
    },
    ['@media (max-width: 768px)']: {
      width: "100%",
      padding: "24px 16px",
    },
  },
  title: {
    display: "block",
    fontSize: "60px",
    lineHeight: "50px",
    textTransform: "uppercase",
    // color: theme.palette.greenMain,
    textShadow: "0px 2px 6px rgba(0, 0, 0, 0.18)",
    marginBottom: "40px",
    ['@media (max-width: 992px)']: {
      fontSize: "40px",
      lineHeight: "50px",
      marginBottom: "24px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "26px",
      lineHeight: "28px",
      marginBottom: "14px",
    },
  },
  text: {
    display: "block",
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: "27px",
    lineHeight: "35px",
    textShadow: "0px 2px 6px rgba(0, 0, 0, 0.18)",
    "& p": {
      marginBottom: "0px"
    },
    ['@media (max-width: 768px)']: {
      fontSize: "14px",
      lineHeight: "18px",
    },
  },
  desktop: {
    display: "flex",
    ['@media (max-width: 768px)']: {
      display: "none",
    }
  },
  mobile: {
    display: "none",
    ['@media (max-width: 768px)']: {
      display: "flex",
    },
  }
}));

const TopInfoBlock = () => {
  const classes = blockStyles();

  return (
    <div className = { classes.root } >
      <ImageSmooth src = { topPicture }
                   width = { '1692px' }
                   height = { '500px' }
                   thumbSrc = { topPictureThumbnail }
                   imageClassName = { classes.imageWide }
                   thumbClassName = { classes.imageWide }
                   wrapperClassName = { classes.imageWrapper } />
      <ImageSmooth src = { topPictureNarrow }
                   width = { '800px' }
                   height = { '533px' }
                   thumbSrc = { topPictureNarrowThumbnail }
                   imageClassName = { classes.imageNarrow }
                   thumbClassName = { classes.imageNarrow }
                   wrapperClassName = { classes.imageWrapper } />
      <Container className = { classes.content } >
        <div className = { classes.textsContainer } >
          {/* Desktop texts */}
          <HtmlContent className = { clsx(classes.title, classes.desktop) } >
            { I18n.t("web.page.index.top_info.title") }
          </HtmlContent>
          <div className = { clsx(classes.checkMarkWrapper, classes.desktop) }>
            <IcCheckSquare className = { classes.checkMark } />
            <HtmlContent className = { clsx(classes.text, classes.checkMarkText) } >
              { I18n.t("web.page.index.top_info.text_1") }
            </HtmlContent>
          </div>
          <div className = { clsx(classes.checkMarkWrapper, classes.desktop) }>
            <IcCheckSquare className = { classes.checkMark } />
            <HtmlContent className = { clsx(classes.text, classes.checkMarkText) } >
              { I18n.t("web.page.index.top_info.text_2") }
            </HtmlContent>
          </div>
          <div className = { clsx(classes.checkMarkWrapper, classes.desktop) }>
            <IcCheckSquare className = { classes.checkMark } />
            <HtmlContent className = { clsx(classes.text, classes.checkMarkText) } >
              { I18n.t("web.page.index.top_info.text_3") }
            </HtmlContent>
          </div>

          {/* Mobile texts */}
          <HtmlContent className = { clsx(classes.title, classes.mobile) } >
            { I18n.t("web.page.index.top_info.title_mobile") }
          </HtmlContent>
          <div className = { clsx(classes.checkMarkWrapper, classes.mobile) }>
            <IcCheckSquare className = { classes.checkMark } />
            <HtmlContent className = { clsx(classes.text, classes.checkMarkText) } >
              { I18n.t("web.page.index.top_info.text_mobile_1") }
            </HtmlContent>
          </div>
          <div className = { clsx(classes.checkMarkWrapper, classes.mobile) }>
            <IcCheckSquare className = { classes.checkMark } />
            <HtmlContent className = { clsx(classes.text, classes.checkMarkText) } >
              { I18n.t("web.page.index.top_info.text_mobile_2") }
            </HtmlContent>
          </div>
          <div className = { clsx(classes.checkMarkWrapper, classes.mobile) }>
            <IcCheckSquare className = { classes.checkMark } />
            <HtmlContent className = { clsx(classes.text, classes.checkMarkText) } >
              { I18n.t("web.page.index.top_info.text_mobile_3") }
            </HtmlContent>
          </div>
        </div>
      </Container>
    </div>
  )
};

export default TopInfoBlock;
